import {grid} from '@xh/hoist/cmp/grid';
import {hframe} from '@xh/hoist/cmp/layout';
import {hoistCmp, uses} from '@xh/hoist/core';
import {button} from '@xh/hoist/desktop/cmp/button';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {Icon} from '@xh/hoist/icon';
import {ConfigurableGridModel} from './ConfigurableGridModel';
import {gridSpecConfigurator} from './configurator/GridSpecConfigurator';
import './GridSpec.scss';

/**
 * A grid driven by a GridSpec. While configuring, the grid goes modal with the configurator
 * docked on the right. A host with linked grids passes its own layout of them as the item, and the whole layout goes modal.
 */
export const configurableGrid = hoistCmp.factory<ConfigurableGridModel>({
    model: uses(ConfigurableGridModel),
    className: 'gs-configurable-grid',
    render({model, className, testId, children}) {
        return panel({
            className,
            model: model.panelModel,
            item: hframe(
                children ?? grid({model: model.gridModel, agOptions: model.agOptions, testId}),
                panel({
                    omit: !model.isConfiguring,
                    className: 'gs-configurator-panel',
                    scrollable: true,
                    modelConfig: {
                        side: 'right',
                        defaultSize: 360,
                        minSize: 300,
                        maxSize: 700,
                        collapsible: false
                    },
                    compactHeader: true,
                    title: model.title ? `Configure: ${model.title}` : 'Configure',
                    icon: Icon.gear(),
                    headerItems: [button({icon: Icon.close(), minimal: true, onClick: () => model.closeConfigurator()})],
                    item: gridSpecConfigurator({model: model.configuratorModel})
                })
            )
        });
    }
});
